import React, { useState } from 'react';
import styles from './list.module.css';
import PortfolioListBox from './project_list_box';
import { projects, projectCategories } from '../../../../data/projects';
export default function PortfolioList() {
 const [category, setCategory] = useState('전체');
 const shown = projects.filter(p => category === '전체' || p.category === category);
 return <section className={styles.section} aria-label="프로젝트 목록"><div className={styles.container}>
 <div className={styles.filters} role="group" aria-label="프로젝트 분류">{['전체',...projectCategories].map(c => <button key={c} type="button" aria-pressed={c===category} onClick={()=>setCategory(c)}>{c}</button>)}</div>
 <p className={styles.count} aria-live="polite">{shown.length}개의 프로젝트</p>
 <ul className={styles.grid}>{shown.map(p => <PortfolioListBox key={p.id} variant={p}/>)}</ul>
 </div></section>;
}
